import gsap from "gsap"
import { CARD_BACK_NOTATION } from "./TrucoGameUtils"

export function dealTrucoCards({
    seats,
    dealerIndex,
    seatRefs,
    dealerRef,
    cardsPerPlayer = 3,
    dealDelay = 0.1,
    dispatch,
    onDealingAnimationCompleted = () => { },
    gameDirection,
    getCardPosition,
    getDealerIconPosition
}) {
    if (!dealerRef.current) return
    clearAllDealtCards(seatRefs)
    const totalSeats = seats.length
    const startIndex = (dealerIndex + 1) % totalSeats
    const myPlayerSeatIndex = seats.findIndex(seat => seat.isMe)
    const tl = gsap.timeline()

    // Track every card still in-flight so snapAll() can commit them instantly
    const pendingCards = []

    // Returns the final resting position for a card at `round` (0-based)
    // given the total number of cards being dealt (cardsPerPlayer).
    const getSlot = (seatIndex, round) => {
        const { x, y, widthGap, heightGap, rotation } = getCardPosition(seatIndex)
        const rotationStep = rotation

        // if (cardsPerPlayer === 3) {
        //     if (round === 0) return { x: x - widthGap, y: y + heightGap, rotation: -rotationStep }
        //     if (round === 1) return { x, y, rotation: 0 }
        //     if (round === 2) return { x: x + widthGap, y: y + heightGap, rotation: rotationStep }
        // }

        // if (cardsPerPlayer === 2) {
        //     const halfGap = widthGap / 2
        //     if (round === 0) return { x: x - halfGap, y: y + heightGap, rotation: -rotationStep }
        //     if (round === 1) return { x: x + halfGap, y: y + heightGap, rotation: rotationStep }
        // }

        return { x, y, rotation: 0 }
    }

    // loop by card round
    for (let round = 0; round < cardsPerPlayer; round++) {
        for (let i = 0; i < totalSeats; i++) {
            const seatIndex = (startIndex + (i * gameDirection) + totalSeats) % totalSeats
            const seatEl = seatRefs.current[seatIndex]
            if (!seatEl) continue

            const cardContainer = seatEl.querySelector(".truco-cards-container")
            if (!cardContainer) continue

            const cardData = seats[seatIndex].cards[round]
            let { x: cardX, y: cardY, width: cardWidth, height: cardHeight, backgroundPosition: { backgroundPosition, spriteWidth, spriteHeight }, widthGap, heightGap, rotation } = getCardPosition(seatIndex, cardData)
            let { x: dealerX, y: dealerY } = getDealerIconPosition(dealerIndex)
            dealerX = dealerX - (cardWidth / 4)
            dealerY = dealerY + (cardHeight / 2)
            let addtionalX = 0, addtionalY = 0;
            if (round === 0) {
                addtionalX = -widthGap;
                addtionalY = 0;
            } else if (round === 2) {
                addtionalX = widthGap;
                addtionalY = heightGap
            }

            cardX = cardX + addtionalX
            cardY = cardY + addtionalY

            let { x: slotX, y: slotY, rotation: slotRotation } = getSlot(seatIndex, round)
            const [imageLeft, imageTop] = backgroundPosition.split(" ")

            // create temp card
            const tempCard = document.createElement("div");
            tempCard.style.backgroundSize = `${spriteWidth}px ${spriteHeight}px`;
            tempCard.className = "truco-card";
            // if (cardData === CARD_BACK_NOTATION) {
            //     tempCard.classList.add("truco-card-back")
            // } else {
            //     tempCard.style.backgroundPosition = backgroundPosition
            // }
            tempCard.style.backgroundPosition = backgroundPosition
            tempCard.style.pointerEvents = "auto";
            tempCard.style.setProperty("--card-width", `${cardWidth}px`);
            tempCard.style.setProperty("--card-height", `${cardHeight}px`);
            tempCard.id = `truco-card-${seatIndex}${round}`
            tempCard.style.transform = ""

            cardContainer.appendChild(tempCard)
            tl.eventCallback("onComplete", onDealingAnimationCompleted)
            gsap.set(tempCard, { position: "absolute", left: 0, bottom: 0 })

            // Register as in-flight so snapAll() can commit it if tab is hidden
            pendingCards.push({ tempCard, seatIndex, cardData, round })

            tl.fromTo(
                tempCard,
                { x: dealerX, y: dealerY, scale: 0, zIndex: 997 + round },
                {
                    x: slotX,
                    y: slotY,
                    scale: 1,
                    duration: 0.4,
                    zIndex: 997 + round,
                    rotate: `${slotRotation}deg`,
                    ease: "power4.out",
                    onComplete: () => {
                        // Remove from pending — this card landed normally
                        const idx = pendingCards.findIndex(p => p.tempCard === tempCard)
                        if (idx !== -1) pendingCards.splice(idx, 1)

                        dispatch({
                            type: "ADD_CARD_TO_SEAT",
                            payload: {
                                seatIndex,
                                card: cardData,
                                cardIndex: round,
                                isMySeat: seatIndex === myPlayerSeatIndex
                            }
                        })
                        tempCard.remove()
                    }
                },
                "+=" + dealDelay
            )
        }
    }

    /**
     * snapAll()
     * Instantly commits every card still in-flight:
     * - Kills the GSAP timeline so no more tweens fire
     * - Dispatches ADD_CARD_TO_SEAT for each un-landed card and removes its temp DOM element
     * - Calls onDealingAnimationCompleted so the game continues normally
     *
     * Called from TableCanvas when the tab becomes visible again after being
     * hidden mid-deal — the user sees all cards already in place, no animation jank.
     */
    tl.snapAll = () => {
        tl.kill()
        const remaining = [...pendingCards]
        pendingCards.length = 0
        remaining.forEach(({ tempCard, seatIndex, cardData, round }) => {
            dispatch({
                type: "ADD_CARD_TO_SEAT",
                payload: {
                    seatIndex,
                    card: cardData,
                    cardIndex: round,
                    isMySeat: seatIndex === myPlayerSeatIndex
                }
            })
            tempCard.remove()
        })
        onDealingAnimationCompleted()
    }

    return tl
}



export function clearAllDealtCards(seatRefs) {
    seatRefs.current.forEach(seatEl => {
        if (!seatEl) return

        const container = seatEl.querySelector(".truco-cards-container")
        if (!container) return

        container.innerHTML = ""
    })
}